import { Switch } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

export default function SwitchProperty({ name }) {
  const { value, setValue } = useCraftProp(name)

  return <Switch
    value={!!value}
    onChange={e => setValue(e.target.checked)}
  />
}
